import { Dto } from '@core/data/dto/dto';
import { DTO_DEFAULT, DtoType } from '@core/data/dto/dto-types';
import { Entity } from '@core/data/dto/entity';
import { DtoImport, DtoExport } from '@core/utils/dto';
import { DeliveryOrderCourierSchema } from './delivery-order-courier.schema';


export class DeliveryOrderCourier implements Entity {
    public id: string;
    public name: string;
    public rating: number;
    public vehicleType: string;
    public phoneNumber: string;
    public imgHref: string;
    public polyline: string;
    public location: { lat, lng };

    @DtoImport(DeliveryOrderCourierSchema)
    static import(dto: Dto): any {}

    @DtoExport([
        {
            type: DTO_DEFAULT,
            dto: DeliveryOrderCourierSchema,
        },
    ])
    export(type?: DtoType): any {}
}
